<template>
  <header>
    <div class="container-fluid no-padding">
      <div class="d-flex flex-row flex-wrap align-items-center header-wrapper">
        <div class="logo flex-grow-1">
           <a href="https://whitebowgiftregistry.com/" v-if="isUserLoggedIn === true">
            <img src="../../../public/assets/images/newLogo.svg" />
          </a>
          <a href="https://whitebowgiftregistry.com/" v-else>
            <img src="../../../public/assets/images/newLogo.svg" />
          </a>
        </div>
       
        <div class="burger-menu flex-grow-2">
        
          <button type="button" id="sidebarCollapse" class="navbar-btn">
            <span></span>
            <span></span>
            <span></span>
          </button>
            <button type="button" id="sidebarHome" class="navbar-btn">
             <router-link :to="{ path: '/dashboard'}" v-if="$route.path !== '/dashboard' && isUserLoggedIn === true">
              <img src="../../../public/assets/images/home-icon.png" />
            
            </router-link>
           </button>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { mapGetters } from "vuex";
import Router from "vue-router";
export default {
  
  computed: {
    ...mapGetters(["isUserLoggedIn"])
  }
};
</script>
<style>
#sidebarHome{
  float:right;
  padding-right:20px;
  z-index:1000 !important;
}
</style>